import { UseMeResponse } from "@/hooks/use-me-query";

const selectIsMale = (data: UseMeResponse) => data.meta?.sex === "male";

export default selectIsMale;
